<!-- Workspace switcher trigger -->
@if (variant === "pill") {
<button
  type="button"
  class="med_workspace-pill d-flex align-items-center gap-2"
  data-cy="med_workspace_popup_trigger"
  (click)="toggle($event)">
  <span
    class="med_ws-tile med_ws-tile-sm d-flex align-items-center justify-content-center"
    [style.background-color]="currentCompany()?.name | hexColor">
    {{ getInitials(currentCompany()?.name || "") }}
  </span>
  <span class="med_workspace-name text-truncate">{{ currentCompany()?.name }}</span>
  <app-icon icon="chevron-down" class="icon-light flex-shrink-0" />
</button>
} @else {
<button
  type="button"
  class="med_workspace-row-trigger d-flex align-items-center gap-3 w-100"
  data-cy="med_workspace_popup_trigger"
  (click)="toggle($event)">
  <span
    class="med_ws-tile med_ws-tile-md d-flex align-items-center justify-content-center flex-shrink-0"
    [style.background-color]="currentCompany()?.name | hexColor">
    {{ getInitials(currentCompany()?.name || "") }}
  </span>
  <div class="d-flex flex-column flex-grow-1 text-start overflow-hidden">
    <p class="s-body secondary-color m-0">{{ "current_workspace" | translate }}</p>
    <p class="xxl-body text-truncate text-capitalize m-0">{{ currentCompany()?.name }}</p>
  </div>
</button>
}

<ng-template #panel>
  <div class="med_workspace-panel" data-cy="med_workspace_popup_panel">
    <div class="med_workspace-current">
      <p class="med_section-label">{{ "current_workspace" | translate }}</p>
      <div
        class="d-flex align-items-center gap-3"
        [class.cursor-pointer]="canManageWorkspace()"
        [attr.role]="canManageWorkspace() ? 'button' : null"
        [attr.tabindex]="canManageWorkspace() ? 0 : null"
        data-cy="med_workspace_popup_current"
        (click)="navigateToWorkspaceManagement()"
        (keydown.enter)="navigateToWorkspaceManagement()"
        (keydown.space)="$event.preventDefault(); navigateToWorkspaceManagement()">
        <span
          class="med_ws-tile med_ws-tile-lg d-flex align-items-center justify-content-center flex-shrink-0"
          [style.background-color]="currentCompany()?.name | hexColor">
          {{ getInitials(currentCompany()?.name || "") }}
        </span>
        <div class="d-flex flex-column overflow-hidden">
          <p class="med_workspace-title text-truncate text-capitalize m-0">{{ currentCompany()?.name }}</p>
          @if (canManageWorkspace()) {
          <p class="med_workspace-link m-0">{{ "members_apps_settings" | translate }}</p>
          }
        </div>
      </div>
    </div>

    @if (companiesList().length > 1) {
    <div class="med_workspace-divider"></div>
    <p class="med_section-label" data-cy="med_workspace_popup_other_label">{{ "other_workspaces" | translate }}</p>
    @for (company of companiesList(); track company.uuid) {
    @if (company.uuid !== currentCompany()?.uuid) {
    <div
      class="med_workspace-row d-flex align-items-center"
      role="button"
      tabindex="0"
      [attr.data-cy]="'med_workspace_popup_item_' + company.name"
      (click)="switchWorkspace(company)"
      (keydown.enter)="switchWorkspace(company)"
      (keydown.space)="$event.preventDefault(); switchWorkspace(company)">
      <span
        class="med_ws-tile med_ws-tile-md d-flex align-items-center justify-content-center flex-shrink-0"
        [style.background-color]="company.name | hexColor">
        {{ getInitials(company.name) }}
      </span>
      <span class="text-truncate text-capitalize">{{ company.name }}</span>
    </div>
    }
    }
    }

    <div class="med_workspace-divider"></div>

    <button
      type="button"
      class="med_workspace-row med_add-workspace d-flex align-items-center w-100"
      data-cy="med_workspace_popup_add_btn"
      (click)="openCreateWorkspaceDialog()">
      <span class="med_add-workspace-icon d-flex align-items-center justify-content-center flex-shrink-0">
        <app-icon icon="plus" class="icon-active" />
      </span>
      <span>{{ "new_workspace" | translate }}</span>
    </button>
  </div>
</ng-template>

<p-popover styleClass="med_header-popover">
  <ng-container *ngTemplateOutlet="panel"></ng-container>
</p-popover>
<!-- #Workspace switcher trigger -->
